import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero headlines. `lines` is an array of strings.
export const MaskedLines = ({ lines, className = "", lineClass = "", start = 0.15 }) => (
  <div className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden pt-[0.2em]">
        <motion.div
          className={lineClass}
          initial={{ y: "112%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: EASE, delay: start + i * 0.12 }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const StaggerItem = ({ children, className = "", index = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, ease: EASE, delay: index * 0.08 }}
  >
    {children}
  </motion.div>
);
